import { API_ROUTES, dataExportSchema } from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from './queries.js';

export const dataExportsQuery = (organizationId: string) =>
  queryOptions({
    queryKey: ['data-exports', organizationId] as const,
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.dataExports.list(organizationId),
        schema: z.array(dataExportSchema),
        signal,
      }),
    // While one is building, look again every few seconds; otherwise leave it.
    refetchInterval: (query) =>
      (query.state.data ?? []).some(
        (item) => item.status === 'queued' || item.status === 'building',
      )
        ? 4_000
        : false,
  });

export function requestDataExport(
  organizationId: string,
  body: { kind: 'everything' | 'year_end'; fiscalYear?: number } = { kind: 'everything' },
) {
  return apiClient.request({
    path: API_ROUTES.dataExports.list(organizationId),
    method: 'POST',
    body,
    schema: dataExportSchema,
  });
}

export function dataExportPartUrl(organizationId: string, exportId: string, index: number) {
  return apiClient.request({
    path: API_ROUTES.dataExports.part(organizationId, exportId, String(index)),
    schema: z.object({ url: z.string() }),
  });
}
